/**
 * @generated SignedSource<<3daf009bf156b4e56387843ebf2f2904>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CompanySocialAccountNetwork = "FACEBOOK" | "LINKEDIN" | "TWITTER" | "%future added value";
export type CompanyProfileCompanyQuery$variables = {
  id: string;
};
export type CompanyProfileCompanyQuery$data = {
  readonly company: {
    readonly allKeywordSummaries: ReadonlyArray<{
      readonly id: string;
      readonly keyword: {
        readonly id: string;
        readonly keywordDe: string;
        readonly keywordEn: string;
      } | null;
      readonly summary: string;
    } | null> | null;
    readonly allOffices: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly country: string | null;
          readonly id: string;
        } | null;
      } | null>;
      readonly totalCount: number | null;
    } | null;
    readonly allSocialAccounts: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly followers: number | null;
          readonly network: CompanySocialAccountNetwork;
          readonly profileUrl: string;
        } | null;
      } | null>;
      readonly totalCount: number | null;
    } | null;
    readonly companyName: string;
    readonly consultantType: {
      readonly consultantTypeDe: string;
      readonly consultantTypeEn: string;
    } | null;
    readonly countries: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly commonNameEn: string;
          readonly iso2letter: string;
        } | null;
      } | null>;
      readonly totalCount: number | null;
    };
    readonly generalInfo: {
      readonly descriptionDe: string | null;
      readonly descriptionEn: string | null;
      readonly email: string | null;
      readonly foundationYear: number | null;
      readonly numberOfEmployees: number | null;
      readonly turnover: string | null;
      readonly turnoverCurrency: {
        readonly isoCurrencyCode: string;
      } | null;
      readonly website: string | null;
    } | null;
    readonly id: string;
    readonly importYear: string | null;
    readonly industries: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly industryEn: string;
        } | null;
      } | null>;
      readonly totalCount: number | null;
    };
    readonly lnCompanySizeEmployees: {
      readonly employeesRangeDe: string;
      readonly employeesRangeEn: string;
    } | null;
    readonly lnCompanySpecialities: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly keywordDe: string;
          readonly keywordEn: string;
        } | null;
      } | null>;
      readonly totalCount: number | null;
    } | null;
    readonly lnCompanyType: {
      readonly companyTypeDe: string;
      readonly companyTypeEn: string;
    } | null;
    readonly logo: string | null;
    readonly reported: boolean | null;
    readonly serviceIndividuals: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly allServices: ReadonlyArray<string | null> | null;
        } | null;
      } | null>;
      readonly totalCount: number | null;
    };
    readonly serviceLine: {
      readonly serviceLineDe: string;
      readonly serviceLineEn: string;
    } | null;
    readonly services: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly serviceEn: string;
        } | null;
      } | null>;
      readonly totalCount: number | null;
    };
    readonly studies: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly descriptionDe: string;
          readonly descriptionEn: string;
          readonly logo: string | null;
          readonly title: string;
          readonly year: number;
        } | null;
      } | null>;
      readonly totalCount: number | null;
    };
    readonly targetIndustries: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly industryDe: string;
          readonly industryEn: string;
        } | null;
      } | null>;
      readonly totalCount: number | null;
    } | null;
  } | null;
};
export type CompanyProfileCompanyQuery = {
  response: CompanyProfileCompanyQuery$data;
  variables: CompanyProfileCompanyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reported",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "network",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "profileUrl",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "followers",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceLineEn",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceLineDe",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allServices",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commonNameEn",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iso2letter",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "descriptionEn",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "descriptionDe",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "foundationYear",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "website",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfEmployees",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "turnover",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoCurrencyCode",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "ServiceStandardNodeConnection",
  "kind": "LinkedField",
  "name": "services",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ServiceStandardNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ServiceStandardNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceEn",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "industryEn",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "IndustryStandardNodeConnection",
  "kind": "LinkedField",
  "name": "industries",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "IndustryStandardNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "IndustryStandardNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v23/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "employeesRangeEn",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "employeesRangeDe",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "consultantTypeEn",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "consultantTypeDe",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyTypeEn",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyTypeDe",
  "storageKey": null
},
v31 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "keywordEn",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "keywordDe",
    "storageKey": null
  }
],
v32 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkedinCompanyKeywordNodeConnection",
  "kind": "LinkedField",
  "name": "lnCompanySpecialities",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkedinCompanyKeywordNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkedinCompanyKeywordNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v31/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "IndustryStandardNodeConnection",
  "kind": "LinkedField",
  "name": "targetIndustries",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "IndustryStandardNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "IndustryStandardNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v23/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "industryDe",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logo",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "CompanyAddressNodeConnection",
  "kind": "LinkedField",
  "name": "allOffices",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyAddressNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CompanyAddressNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "country",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "concreteType": "CompanyKeywordSummaryNode",
  "kind": "LinkedField",
  "name": "allKeywordSummaries",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkedinCompanyKeywordNode",
      "kind": "LinkedField",
      "name": "keyword",
      "plural": false,
      "selections": (v31/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "summary",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "importYear",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CompanyProfileCompanyQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CompanyNode",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CompanySocialAccountNodeConnection",
            "kind": "LinkedField",
            "name": "allSocialAccounts",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CompanySocialAccountNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanySocialAccountNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ServiceLineNode",
            "kind": "LinkedField",
            "name": "serviceLine",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ServiceIndividualNodeConnection",
            "kind": "LinkedField",
            "name": "serviceIndividuals",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ServiceIndividualNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ServiceIndividualNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CountryNodeConnection",
            "kind": "LinkedField",
            "name": "countries",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CountryNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CountryNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GeneralInfoNode",
            "kind": "LinkedField",
            "name": "generalInfo",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CurrencyNode",
                "kind": "LinkedField",
                "name": "turnoverCurrency",
                "plural": false,
                "selections": [
                  (v21/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v22/*: any*/),
          (v24/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "LinkedinCompanySizeEmployeesNode",
            "kind": "LinkedField",
            "name": "lnCompanySizeEmployees",
            "plural": false,
            "selections": [
              (v25/*: any*/),
              (v26/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ConsultantTypeNode",
            "kind": "LinkedField",
            "name": "consultantType",
            "plural": false,
            "selections": [
              (v27/*: any*/),
              (v28/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LinkedinCompanyTypeNode",
            "kind": "LinkedField",
            "name": "lnCompanyType",
            "plural": false,
            "selections": [
              (v29/*: any*/),
              (v30/*: any*/)
            ],
            "storageKey": null
          },
          (v32/*: any*/),
          (v33/*: any*/),
          (v34/*: any*/),
          (v35/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StudyNodeConnection",
            "kind": "LinkedField",
            "name": "studies",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StudyNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StudyNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v36/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v37/*: any*/),
                      (v34/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v38/*: any*/),
          (v39/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CompanyProfileCompanyQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CompanyNode",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CompanySocialAccountNodeConnection",
            "kind": "LinkedField",
            "name": "allSocialAccounts",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CompanySocialAccountNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompanySocialAccountNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ServiceLineNode",
            "kind": "LinkedField",
            "name": "serviceLine",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ServiceIndividualNodeConnection",
            "kind": "LinkedField",
            "name": "serviceIndividuals",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ServiceIndividualNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ServiceIndividualNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v11/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CountryNodeConnection",
            "kind": "LinkedField",
            "name": "countries",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CountryNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CountryNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GeneralInfoNode",
            "kind": "LinkedField",
            "name": "generalInfo",
            "plural": false,
            "selections": [
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CurrencyNode",
                "kind": "LinkedField",
                "name": "turnoverCurrency",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v22/*: any*/),
          (v24/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "LinkedinCompanySizeEmployeesNode",
            "kind": "LinkedField",
            "name": "lnCompanySizeEmployees",
            "plural": false,
            "selections": [
              (v25/*: any*/),
              (v26/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ConsultantTypeNode",
            "kind": "LinkedField",
            "name": "consultantType",
            "plural": false,
            "selections": [
              (v27/*: any*/),
              (v28/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LinkedinCompanyTypeNode",
            "kind": "LinkedField",
            "name": "lnCompanyType",
            "plural": false,
            "selections": [
              (v29/*: any*/),
              (v30/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v32/*: any*/),
          (v33/*: any*/),
          (v34/*: any*/),
          (v35/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StudyNodeConnection",
            "kind": "LinkedField",
            "name": "studies",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "StudyNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StudyNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v36/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v37/*: any*/),
                      (v34/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v38/*: any*/),
          (v39/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "cf4920f213993ead269ee7fa5623db84",
    "id": null,
    "metadata": {},
    "name": "CompanyProfileCompanyQuery",
    "operationKind": "query",
    "text": "query CompanyProfileCompanyQuery(\n  $id: ID!\n) {\n  company(id: $id) {\n    id\n    companyName\n    reported\n    allSocialAccounts {\n      totalCount\n      edges {\n        node {\n          network\n          profileUrl\n          followers\n          id\n        }\n      }\n    }\n    serviceLine {\n      serviceLineEn\n      serviceLineDe\n      id\n    }\n    serviceIndividuals {\n      totalCount\n      edges {\n        node {\n          allServices\n          id\n        }\n      }\n    }\n    countries {\n      totalCount\n      edges {\n        node {\n          commonNameEn\n          iso2letter\n          id\n        }\n      }\n    }\n    generalInfo {\n      descriptionEn\n      descriptionDe\n      foundationYear\n      website\n      email\n      numberOfEmployees\n      turnover\n      turnoverCurrency {\n        isoCurrencyCode\n        id\n      }\n      id\n    }\n    services {\n      totalCount\n      edges {\n        node {\n          id\n          serviceEn\n        }\n      }\n    }\n    industries {\n      totalCount\n      edges {\n        node {\n          id\n          industryEn\n        }\n      }\n    }\n    lnCompanySizeEmployees {\n      employeesRangeEn\n      employeesRangeDe\n      id\n    }\n    consultantType {\n      consultantTypeEn\n      consultantTypeDe\n      id\n    }\n    lnCompanyType {\n      companyTypeEn\n      companyTypeDe\n      id\n    }\n    lnCompanySpecialities {\n      totalCount\n      edges {\n        node {\n          id\n          keywordEn\n          keywordDe\n        }\n      }\n    }\n    targetIndustries {\n      totalCount\n      edges {\n        node {\n          id\n          industryEn\n          industryDe\n        }\n      }\n    }\n    logo\n    allOffices {\n      totalCount\n      edges {\n        node {\n          id\n          country\n        }\n      }\n    }\n    studies {\n      totalCount\n      edges {\n        node {\n          title\n          descriptionEn\n          descriptionDe\n          year\n          logo\n          id\n        }\n      }\n    }\n    allKeywordSummaries {\n      id\n      keyword {\n        id\n        keywordEn\n        keywordDe\n      }\n      summary\n    }\n    importYear\n  }\n}\n"
  }
};
})();

(node as any).hash = "3275c03a0b38ab875350bef0ca2cb157";

export default node;
